import { FC, ReactNode, useState, useEffect } from "react";
import { useStyles } from "./Borrowerlayout.styles";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { IconHome, IconPhotoDollar, IconSignature } from "@tabler/icons-react";
import NavBar from "../../components/NavBar/NavBar";
import SystemUpgradeModal from "../../components/SystemUpgradeModal/SystemUpgradeModal";

interface IProps {
  content: ReactNode;
}

const BorrowerLayout: FC<IProps> = ({ content }) => {
  const { classes } = useStyles();
  const { hasCreditLimit, declarationAISubmitted } = useSelector(
    (state: RootState) => state.auth
  );
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Show modal when declarationAISubmitted is true
  useEffect(() => {
    if (declarationAISubmitted) {
      setShowUpgradeModal(true);
    }
  }, [declarationAISubmitted]);

  const menus = [
    // {
    //   label: "Dashboard",
    //   path: "/merchant-dashboard/Overall",
    //   icon: <IconHome />,
    // },
    {
      label: "Collaboration Proposal",
      path: "/collaboration-proposal/submission",
      icon: <IconPhotoDollar />,
    },
    {
      label: "Signed Documents",
      path: "/signed-documents",
      icon: <IconSignature />,
    },
  ];

  return (
    <div className={classes.mainContainer}>
      {/* <div className={classes.sideBarContainer}>
        <div className={classes.iconbox}>
          <img className={classes.logo} alt="LOGO" src={LoginIcon} />
        </div>
        {hasCreditLimit && (
          <div>
            {menus.map((data, index) => (
              <>
                <div
                  key={index}
                  className={classes.sideDiv}
                  onClick={() => toggleSubMenu(index)}
                >
                  <Link to={data.path} className={classes.Link}>
                    {data.icon}
                    <p className={classes.label}> {data.label}</p>
                  </Link>
                </div>
              </>
            ))}
          </div>
        )}

        <div className={classes.labelLog} onClick={handleLogout}>
          <div className={classes.persona}>
            <Text>
              {name.firstName} {name.lastName}
            </Text>
          </div>
          <img src={logoutIcon} alt="Logout Icon" className={classes.icon} />
          Logout
        </div>
      </div> */}
      <NavBar menus={menus} canPassCondition={hasCreditLimit} />
      <ToastContainer />
      <SystemUpgradeModal
        opened={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />
      <div style={{ paddingBottom: "30px" }} className={classes.hero}>
        {content}
      </div>
    </div>
  );
};

export default BorrowerLayout;
